const countdown = (elements) => {
  if (!elements) {
    return;
  }

  elements.forEach( (element) => {
    updateTime( element );
    setInterval( () => updateTime( element ), 1000 );
  } );
}

const updateTime = (element) => {
  if (element.classList.contains( 'is-hidden' )) {
    return;
  }

  let countdownTo = parseInt( element.dataset.countdown, 10 );

  if (countdownTo < 0) {
    element.classList.add( 'is-hidden' );
    setTimeout( () => element.remove(), 6000 );

    return;
  }

  const countdownSplit = secondsToDHM( countdownTo );
  const countdownValueDaysElement = element.querySelector( '[data-countdown-value="days"]' );
  const countdownValueHoursElement = element.querySelector( '[data-countdown-value="hours"]' );
  const countdownValueMinutesElement = element.querySelector( '[data-countdown-value="minutes"]' );
  const countdownValueSecondsElement = element.querySelector( '[data-countdown-value="seconds"]' );
  const countdownLabelDaysElement = element.querySelector( '[data-countdown-label="days"]' );
  const countdownLabelHoursElement = element.querySelector( '[data-countdown-label="hours"]' );
  const countdownLabelMinutesElement = element.querySelector( '[data-countdown-label="minutes"]' );
  const countdownLabelSecondsElement = element.querySelector( '[data-countdown-label="seconds"]' );

  if (!!window.matchMedia( '(prefers-reduced-motion: reduce)' )) {
    countdownValueSecondsElement.style.opacity = 1;
    if (countdownTo > 0) {
      setTimeout( () => countdownValueSecondsElement.style.opacity = .5, 600 );
    }
  }

  countdownValueDaysElement.innerText = countdownSplit.days;
  countdownValueHoursElement.innerText = countdownSplit.hours;
  countdownValueMinutesElement.innerText = countdownSplit.minutes;
  countdownValueSecondsElement.innerText = countdownSplit.seconds;

  countdownLabelDaysElement.innerText = countdownSplit.days === 1 ? countdownLabelDaysElement.dataset.countdownLabelSingular : countdownLabelDaysElement.dataset.countdownLabelPlural;
  countdownLabelHoursElement.innerText = countdownSplit.hours === 1 ? countdownLabelHoursElement.dataset.countdownLabelSingular : countdownLabelHoursElement.dataset.countdownLabelPlural;
  countdownLabelMinutesElement.innerText = countdownSplit.minutes === 1 ? countdownLabelMinutesElement.dataset.countdownLabelSingular : countdownLabelMinutesElement.dataset.countdownLabelPlural;
  countdownLabelSecondsElement.innerText = countdownSplit.seconds === 1 ? countdownLabelSecondsElement.dataset.countdownLabelSingular : countdownLabelSecondsElement.dataset.countdownLabelPlural;

  countdownTo--;
  element.dataset.countdown = countdownTo.toString();
}

const secondsToDHM = (seconds) => {
  seconds = Number( seconds );
  return {
    days: Math.floor( seconds / (3600 * 24) ),
    hours: Math.floor( seconds % (3600 * 24) / 3600 ),
    minutes: Math.floor( seconds % 3600 / 60 ),
    seconds: Math.floor( seconds % 60 ),
  };
}

export default countdown;
